import { computed, inject, Injectable, Signal } from '@angular/core';
import { AuthService } from '@libs/shared/auth';
import { CapabilityAccessChecker, CapabilityName } from '../capability.model';

@Injectable({ providedIn: 'root' })
export class PermissionAccessCheckerService extends CapabilityAccessChecker {
  protected readonly authService: AuthService = inject(AuthService);

  protected readonly capabilities: Partial<Record<CapabilityName, Signal<boolean>>> = {
    'services.srm': computed(() => this.authService.currentCustomer()?.customerUserPermissions.canUseSrm ?? false),
  };

  public canUse(name: CapabilityName): Signal<boolean | undefined> {
    return this.capabilities[name] ?? this.neutralResult;
  }
}
